import React from "react";
import { ScrollView } from "react-native";
import { useGlobal } from "../../Context/globalContext";
import ModalBase from "@/Components/Screens/Modals/ModalBase";
import Markdown from "react-native-markdown-display";

const ModalInici = (setHideModalInici: any) => {
  const { textRecurs, imatgeRecurs, projecte, __ } = useGlobal();

  return (
    <ModalBase
      setModalVisible={setHideModalInici}
      title={textRecurs("general_popup_inicial_titol")}
    >
      <ScrollView>
        <Markdown
          style={{
            body: { fontSize: 16, color: projecte.color_principal },
            image: { width: 32, height: 32, flex: 0, marginRight: 40 },
            em: { fontSize: 12 },
          }}
        >
          {__(projecte, "popup_inicial") || " "}
        </Markdown>
      </ScrollView>
    </ModalBase>
  );
};

export default ModalInici;
